import React from "react";

function AboutCard() {
  return (
    <div className="about-profile">
      <p className="about-profile-intro">
        I’m a backend-focused full-stack software engineer with{" "}
        <strong className="purple">5+ years of experience</strong> building and
        maintaining applications, from individual services to complete products.
      </p>

      <section className="about-capability" aria-labelledby="about-delivery">
        <h2 id="about-delivery">Independent project delivery</h2>
        <p>
          I take projects from requirements and system design through
          implementation, deployment, and ongoing maintenance. I’m comfortable
          working across backend services, user interfaces, databases, and
          infrastructure.
        </p>
      </section>

      <section className="about-capability" aria-labelledby="about-backend">
        <h2 id="about-backend">Backend and data systems</h2>
        <p>
          My core expertise includes Java, Spring Boot, RESTful APIs, and
          microservices. I work with MySQL, Redis, and InfluxDB, including database
          design, SQL optimisation, caching, and performance troubleshooting.
        </p>
      </section>

      <section className="about-capability" aria-labelledby="about-fullstack">
        <h2 id="about-fullstack">Full-stack application development</h2>
        <p>
          I build web and mobile interfaces with JavaScript, Vue.js, uni-app, and
          Cocos Creator, connecting user-facing experiences to backend services
          and data systems.
        </p>
      </section>

      <section className="about-capability" aria-labelledby="about-ai">
        <h2 id="about-ai">AI agents, RAG, and reusable skills</h2>
        <p>
          I develop AI agents and applications with Python, LangChain, and OpenAI
          APIs. My work includes retrieval-augmented generation (RAG) workflows,
          tool integration, and reusable agent skills that turn repeatable tasks
          into structured workflows.
        </p>
        <p>
          I connect language models with application APIs and relevant knowledge
          sources to build contextual assistants and automate multi-step tasks.
        </p>
      </section>

      <section className="about-capability" aria-labelledby="about-operations">
        <h2 id="about-operations">Deployment and ongoing maintenance</h2>
        <p>
          I deploy and maintain applications using Linux, AWS, Docker, and Nginx,
          with Jenkins-based CI/CD workflows. My work includes diagnosing
          production issues, managing releases, and maintaining applications as
          requirements evolve.
        </p>
      </section>
    </div>
  );
}

export default AboutCard;
